"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const luxon_1 = require("luxon");
const mui_1 = require("tss-react/mui");
const Stop_1 = __importDefault(require("@mui/icons-material/Stop"));
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const CardHeader_1 = __importDefault(require("@mui/material/CardHeader"));
const ChevronLeftRounded_1 = __importDefault(require("@mui/icons-material/ChevronLeftRounded"));
const ChevronRightRounded_1 = __importDefault(require("@mui/icons-material/ChevronRightRounded"));
const SettingsRounded_1 = __importDefault(require("@mui/icons-material/SettingsRounded"));
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.headerStyles);
const prevYears = 10;
const nextYears = 5;
const prevYearsArray = [...Array(prevYears).keys()].map((i) => luxon_1.DateTime.local().year - (i + 1)).reverse();
const nextYearsArray = [...Array(nextYears).keys()].map((i) => luxon_1.DateTime.local().year + (i + 1));
const yearsData = [...prevYearsArray, luxon_1.DateTime.local().year, ...nextYearsArray]
    .map((year) => ({ key: `${year}`, label: `${year}`, value: year }));
const monthsData = luxon_1.Info.months().map((month, index) => ({
    key: month, label: month, index: index + 1,
}));
const Header = ({ updateDateState, onPrefsOpen, curMonth: { date = null } }) => {
    var _a;
    const { classes, cx } = useStyles();
    const monthSelectedIndex = date.month - 1;
    const yearSelectedIndex = yearsData.findIndex((y) => y.value === (date === null || date === void 0 ? void 0 : date.year));
    const onNextMonth = (0, react_1.useCallback)((event) => {
        event.stopPropagation();
        updateDateState(date.plus({ months: 1 }), 'next-month');
    }, [updateDateState, date]);
    const onPrevMonth = (0, react_1.useCallback)((event) => {
        event.stopPropagation();
        updateDateState(date.minus({ months: 1 }), 'previous-month');
    }, [updateDateState, date]);
    const onCurrentMonth = (0, react_1.useCallback)((event) => {
        event.stopPropagation();
        updateDateState(luxon_1.DateTime.local(), 'current-month');
    }, [updateDateState]);
    const disablePrevBtn = (0, react_1.useMemo)(() => {
        var _a;
        const firstYear = yearsData && luxon_1.DateTime.local((_a = yearsData[0]) === null || _a === void 0 ? void 0 : _a.value).minus({ months: 1 }).toISODate();
        return firstYear === (date === null || date === void 0 ? void 0 : date.minus({ months: 1 }).toISODate());
    }, [date]);
    const disableNextBtn = (0, react_1.useMemo)(() => {
        var _a;
        const lastYear = yearsData && luxon_1.DateTime.local((_a = yearsData[yearsData.length - 1]) === null || _a === void 0 ? void 0 : _a.value, 12).plus({ months: 1 }).toISODate();
        return lastYear === (date === null || date === void 0 ? void 0 : date.plus({ months: 1 }).toISODate());
    }, [date]);
    return (<header className={classes.monthHeader}>
      <div className={classes.controlGroup}>
        <div className={classes.controlRoot}>
          <ButtonBase_1.default id="cal-prev-month" className={cx(classes.iconControl, { [classes.iconControlDisabled]: disablePrevBtn })} onClick={onPrevMonth} disabled={disablePrevBtn}>
            <ChevronLeftRounded_1.default />
          </ButtonBase_1.default>
        </div>
        <div className={classes.controlRoot}>
          <ButtonBase_1.default id="cal-current-month" className={classes.iconControl} onClick={onCurrentMonth}>
            <Stop_1.default className={classes.iconToday}/>
          </ButtonBase_1.default>
        </div>
        <div className={classes.controlRoot}>
          <ButtonBase_1.default id="cal-next-month" className={cx(classes.iconControl, { [classes.iconControlDisabled]: disableNextBtn })} onClick={onNextMonth} disabled={disableNextBtn}>
            <ChevronRightRounded_1.default />
          </ButtonBase_1.default>
        </div>
        <div className={classes.settingsRoot}>
          <ButtonBase_1.default id="cal-settings" className={cx(classes.iconControl)} onClick={onPrefsOpen}>
            <SettingsRounded_1.default className={classes.settingsIcon}/>
          </ButtonBase_1.default>
        </div>
      </div>
      {date && (<CardHeader_1.default title={`${monthsData[monthSelectedIndex].label} ${(_a = yearsData[yearSelectedIndex]) === null || _a === void 0 ? void 0 : _a.label}`} titleTypographyProps={{
                id: 'title',
                variant: 'subtitle1',
                color: 'textPrimary',
            }} subheaderTypographyProps={{
                variant: 'body2',
                color: 'textSecondary',
            }} classes={{
                root: classes.cardHeaderNotClickable,
                action: classes.actions,
                title: classes.title,
            }}/>)}
    </header>);
};
exports.default = (0, react_1.memo)(Header);
